import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import api from './api'
import * as Sentry from "@sentry/vue";
import { useDiscountTimerStore } from './stores/discountTimer'
// Инициализация SVG спрайтов
import 'virtual:svg-icons-register'


const app = createApp(App)
const pinia = createPinia()

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: "https://fff8e93672e5135e226eeb77ddaed7a4@o4508052965752832.ingest.us.sentry.io/4509355662245888",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

// Добавляем API к глобальным свойствам
app.config.globalProperties.$api = api

app.use(pinia)
app.use(router)

// Инициализация discount timer
const discountTimerStore = useDiscountTimerStore()
discountTimerStore.init(20 * 60)

app.mount('#app')
